<template>
  <section id="portfolio" class="py-12 portfolio-section bg-red-lighten-5">
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center mb-8">
          <h2 class="text-h3 font-weight-bold mb-4">Kundenstimmen</h2>
          <p class="text-h6 font-weight-light">Explore my latest work...</p>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col 
          v-for="(item, i) in portfolioItems" 
          :key="i" 
          cols="12" 
          md="4" 
          sm="6"
        >
          <v-card class="portfolio-card" hover @click="openImage(item)">
            <v-img :src="item.image" height="300" class="portfolio-image"></v-img>
            <v-card-title class="font-weight-bold">{{ item.title }}</v-card-title>
            <v-card-subtitle>{{ item.category }}</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface PortfolioItem {
  title: string;
  category: string;
  image: string;
  description: string;
}

export default defineComponent({
  name: 'PortfolioComponent',
  data() {
    return {
      portfolioItems: [
        {
          title: 'Urban Portrait',
          category: 'Portrait',
          image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
          description: 'A stunning urban portrait series captured in downtown Berlin.'
        },
        {
          title: 'Summer Wedding',
          category: 'Wedding',
          image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
          description: 'Beautiful summer wedding ceremony in a countryside villa.'
        },
        {
          title: 'Product Shoot',
          category: 'Commercial',
          image: 'https://images.unsplash.com/photo-1607083206968-13611e3d76db?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
          description: 'Professional product photography for a luxury brand.'
        },
        {
          title: 'Family Moments',
          category: 'Portrait',
          image: 'https://images.unsplash.com/photo-1511988617509-a57c8a288659?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
          description: 'Heartwarming family portraits in a natural park setting.'
        },
        {
          title: 'Fashion Editorial',
          category: 'Commercial',
          image: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
          description: 'Editorial fashion shoot for a leading magazine.'
        },
        {
          title: 'Golden Hour',
          category: 'Portrait',
          image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
          description: 'Portrait session during the magical golden hour.'
        }
      ] as PortfolioItem[]
    };
  },
  methods: {
    openImage(item: PortfolioItem): void {
      this.$emit('open-image', item);
    }
  },
  emits: ['open-image']
});
</script>

<style scoped>
.portfolio-section {
  background-color: #f5f5f5;
  scroll-margin-top: 64px;
}

.portfolio-card {
  transition: transform 0.3s ease;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.portfolio-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2) !important;
}

.portfolio-image {
  transition: transform 0.5s ease;
}

.portfolio-card:hover .portfolio-image {
  transform: scale(1.05);
}

@media (max-width: 960px) {
  .portfolio-section {
    scroll-margin-top: 56px;
  }
}
</style>